import { render, staticRenderFns } from "./AccountBanksCreate.vue?vue&type=template&id=0454abb6&scoped=true"
import script from "./AccountBanksCreate.vue?vue&type=script&lang=js"
export * from "./AccountBanksCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454abb6",
  null
  
)

export default component.exports